export type MissionPlatform = "1U" | "3U" | "6U" | "Other";
export type MissionOrbit = "LEO" | "MEO" | "HEO" | "GEO" | "Other";

// Physical dimensions per CubeSat size are fixed knowledge, not stored per
// mission row -- derived here from missions.platform_type.
export const PLATFORM_INFO: Record<MissionPlatform, { label: string; dimensions?: string }> = {
  "1U": { label: "1U CubeSat", dimensions: "10×10×10 cm" },
  "3U": { label: "3U CubeSat", dimensions: "30×30×30 cm" },
  "6U": { label: "6U CubeSat", dimensions: "60×60×60 cm" },
  Other: { label: "Other" },
};

export const ORBIT_INFO: Record<MissionOrbit, { label: string; description: string }> = {
  LEO: { label: "LEO", description: "Low Earth Orbit — multiple passes per day" },
  MEO: { label: "MEO", description: "Medium Earth Orbit" },
  HEO: { label: "HEO", description: "Highly Elliptical Orbit" },
  GEO: { label: "GEO", description: "Geostationary Orbit" },
  Other: { label: "Other", description: "Other orbit type" },
};

export function formatPlatform(type: MissionPlatform): string {
  const info = PLATFORM_INFO[type];
  return info.dimensions ? `${info.label} (${info.dimensions})` : info.label;
}

export function formatOrbit(type: MissionOrbit): string {
  const info = ORBIT_INFO[type];
  return `${info.label} (${info.description})`;
}
